export enum LanguageKey {
  ACTIVATE = 'ACTIVATE',
  AN_ERROR_HAS_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST = 'AN_ERROR_HAS_OCCURRED_WHILE_PROCESSING_YOUR_REQUEST',
  ATTENDANT_ID_REQUIRED = 'ATTENDANT_ID_REQUIRED',
  CANCEL = 'CANCEL',
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
  CHARACTERS = 'CHARACTERS',
  CONFIRM = 'CONFIRM',
  CODE = 'CODE',
  COULD_NOT_ACTIVATE_THE_ITEM = 'COULD_NOT_ACTIVATE_THE_ITEM',
  COULD_NOT_DELETE_THE_ITEM = 'COULD_NOT_DELETE_THE_ITEM',
  COULD_NOT_INACTIVATE_THE_ITEM = 'COULD_NOT_INACTIVATE_THE_ITEM',
  DELETE = 'DELETE',
  DESCRIPTION = 'DESCRIPTION',
  DETAILS = 'DETAILS',
  DATE = 'DATE',
  DONE = 'DONE',
  DO_YOU_REALLY_WANT_TO_ACTIVATE_THIS_ITEM = 'DO_YOU_REALLY_WANT_TO_ACTIVATE_THIS_ITEM',
  DO_YOU_REALLY_WANT_TO_DELETE_THE_REGISTER = 'DO_YOU_REALLY_WANT_TO_DELETE_THE_REGISTER',
  DO_YOU_REALLY_WANT_TO_DELETE_THIS_ITEM = 'DO_YOU_REALLY_WANT_TO_DELETE_THIS_ITEM',
  DO_YOU_REALLY_WANT_TO_INACTIVATE_THIS_ITEM = 'DO_YOU_REALLY_WANT_TO_INACTIVATE_THIS_ITEM',
  DO_YOU_WANT_TO_EXIT = 'DO_YOU_WANT_TO_EXIT',
  EDIT = 'EDIT',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  ENGLISH = 'ENGLISH',
  ENTER_YOUR_EMAIL = 'ENTER_YOUR_EMAIL',
  ENTER_YOUR_PASSWORD = 'ENTER_YOUR_PASSWORD',
  ENTRIES = 'ENTRIES',
  GENERAL_DATA = 'GENERAL_DATA',
  HELLO = 'HELLO',
  ACTIVE = 'ACTIVE',
  AUTHENTICATION_HAPPENS_THROUGH_VIDEOSOFT_CENTRALIZED_LOGIN = 'AUTHENTICATION_HAPPENS_THROUGH_VIDEOSOFT_CENTRALIZED_LOGIN',
  INACTIVATE = 'INACTIVATE',
  INACTIVE = 'INACTIVE',
  INFORM_THE = 'INFORM_THE',
  INFORM_THE_FEMALE = 'INFORM_THE_FEMALE',
  INVALID_CNPJ = 'INVALID_CNPJ',
  INVALID_DATE = 'INVALID_DATE',
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT',
  INVALID_FORMAT = 'INVALID_FORMAT',
  ITEM_SUCCESSFULLY_ACTIVATED = 'ITEM_SUCCESSFULLY_ACTIVATED',
  ITEM_SUCCESSFULLY_DELETED = 'ITEM_SUCCESSFULLY_DELETED',
  ITEM_SUCCESSFULLY_INACTIVATED = 'ITEM_SUCCESSFULLY_INACTIVATED',
  LOG_IN_TO_CONTINUE = 'LOG_IN_TO_CONTINUE',
  LOGIN_WITH_VIDEOSOFT = 'LOGIN_WITH_VIDEOSOFT',
  MUST_BE_A_MAXIMUM = 'MUST_BE_A_MAXIMUM',
  MUST_BE_A_MINIMUM = 'MUST_BE_A_MINIMUM',
  NAME = 'NAME',
  NEW = 'NEW',
  NO = 'NO',
  OF = 'OF',
  PASSWORD = 'PASSWORD',
  PORTUGUESE = 'PORTUGUESE',
  RECORDS = 'RECORDS',
  REQUEST_PROCESSED_SUCCESSFULLY = 'REQUEST_PROCESSED_SUCCESSFULLY',
  REQUIRED = 'REQUIRED',
  REQUIRED_FIELD = 'REQUIRED_FIELD',
  SAVE = 'SAVE',
  LIST = 'LIST',
  CALENDAR = 'CALENDAR',
  SEARCH = 'SEARCH',
  SHOWING = 'SHOWING',
  SPANISH = 'SPANISH',
  TO = 'TO',
  TO_DO = 'To-Do',
  YES = 'YES',
  WELCOME = 'WELCOME',
  MANAGE = 'MANAGE',
  NO_DATA_FOUND = 'NO_DATA_FOUND',
  SPACE_SUCCESSFULLY_ACTIVATED = 'SPACE_SUCCESSFULLY_ACTIVATED',
  SPACE_SUCCESSFULLY_DELETED = 'SPACE_SUCCESSFULLY_DELETED',
  SPACE_SUCCESSFULLY_INACTIVATED = 'SPACE_SUCCESSFULLY_INACTIVATED',
  SPACE_SUCCESSFULLY_UPDATED = 'SPACE_SUCCESSFULLY_UPDATED',
  SPACE_SUCCESSFULLY_CREATED = 'SPACE_SUCCESSFULLY_CREATED',
  SPACES = 'SPACES',
  SPACE = 'SPACE',
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
  SELECT_A = 'SELECT_A',
  MEDIA = 'MEDIA',
  MEDIAS = 'MEDIAS',
  DIMENSIONS = 'DIMENSIONS',
  DURATION = 'DURATION',
  ERROR_IN_THE_CODE = 'ERROR_IN_THE_CODE',
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  WEEK_ABBR_SUNDAY = 'WEEK_ABBR_SUNDAY',
  WEEK_ABBR_MONDAY = 'WEEK_ABBR_MONDAY',
  WEEK_ABBR_TUESDAY = 'WEEK_ABBR_TUESDAY',
  WEEK_ABBR_WEDNESDAY = 'WEEK_ABBR_WEDNESDAY',
  WEEK_ABBR_THURSDAY = 'WEEK_ABBR_THURSDAY',
  WEEK_ABBR_FRIDAY = 'WEEK_ABBR_FRIDAY',
  WEEK_ABBR_SATURDAY = 'WEEK_ABBR_SATURDAY',
  WEEK = 'WEEK',
  MONTH_ABBR_JANUARY = 'MONTH_ABBR_JANUARY',
  MONTH_ABBR_FEBRUARY = 'MONTH_ABBR_FEBRUARY',
  MONTH_ABBR_MARCH = 'MONTH_ABBR_MARCH',
  MONTH_ABBR_APRIL = 'MONTH_ABBR_APRIL',
  MONTH_ABBR_MAY = 'MONTH_ABBR_MAY',
  MONTH_ABBR_JUNE = 'MONTH_ABBR_JUNE',
  MONTH_ABBR_JULY = 'MONTH_ABBR_JULY',
  MONTH_ABBR_AUGUST = 'MONTH_ABBR_AUGUST',
  MONTH_ABBR_SEPTEMBER = 'MONTH_ABBR_SEPTEMBER',
  MONTH_ABBR_OCTOBER = 'MONTH_ABBR_OCTOBER',
  MONTH_ABBR_NOVEMBER = 'MONTH_ABBR_NOVEMBER',
  MONTH_ABBR_DECEMBER = 'MONTH_ABBR_DECEMBER',
  CHOOSE = 'CHOOSE',
  WAIT = 'WAIT',
  PRIORITIES = 'PRIORITIES',
  PRIORITY = 'PRIORITY',
  CLIENT = 'CLIENT',
  CLIENTS = 'CLIENTS',
  APPOINTMENT = 'APPOINTMENT',
  APPOINTMENTS = 'APPOINTMENTS',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  TIME = 'TIME',
  WEIGHT = 'WEIGHT',
  STATUS = 'STATUS',
  PERSONALIZACAO = 'PERSONALIZACAO',
  PREVIEW_BUTTON_TOTEM = 'PREVIEW_BUTTON_TOTEM',
  PRIORITY_COLOR = 'PRIORITY_COLOR',
  SERVICES_GROUPS = 'SERVICES_GROUPS',
  SERVICE_GROUP = 'SERVICE_GROUP',
  SERVICES_THIS_SERVICE_GROUP = 'SERVICES_THIS_SERVICE_GROUP',
  SERVICES = 'SERVICES',
  SERVICE = 'SERVICE',
  SERVICE_PRIORITIES = 'SERVICE_PRIORITIES',
  SERVICE_NAME_MUST_BE_UNIQUE = 'SERVICE_NAME_MUST_BE_UNIQUE',
  SERVICE_WEIGHT_MUST_BE_POSITIVE = 'SERVICE_WEIGHT_MUST_BE_POSITIVE',
  SERVICE_MAXIMUM_TIME_MUST_BE_POSITIVE = 'SERVICE_MAXIMUM_TIME_MUST_BE_POSITIVE',
  SERVICE_CANNOT_BE_ITS_OWN_PARENT = 'SERVICE_CANNOT_BE_ITS_OWN_PARENT',
  SERVICE_PARENT_CYCLE_NOT_ALLOWED = 'SERVICE_PARENT_CYCLE_NOT_ALLOWED',
  SELECT_AUTHENTICATED_USER = 'SELECT_AUTHENTICATED_USER',
  SELECT_SERVICE_GROUP_TO_ENABLE_SERVICES_FOR_THIS_ATTENDANT = 'SELECT_SERVICE_GROUP_TO_ENABLE_SERVICES_FOR_THIS_ATTENDANT',
  PRIORITY_NAME_MUST_BE_UNIQUE = 'PRIORITY_NAME_MUST_BE_UNIQUE',
  RESOLUTION_NAME_MUST_BE_UNIQUE = 'RESOLUTION_NAME_MUST_BE_UNIQUE',
  SERVICE_GROUP_NAME_MUST_BE_UNIQUE = 'SERVICE_GROUP_NAME_MUST_BE_UNIQUE',
  LOCATION_NAME_MUST_BE_UNIQUE = 'LOCATION_NAME_MUST_BE_UNIQUE',
  PRIORITY_WEIGHT_MUST_BE_POSITIVE = 'PRIORITY_WEIGHT_MUST_BE_POSITIVE',
  EMPTY_REGISTERS_OF = 'EMPTY_REGISTERS_OF',
  ACRONYM = 'ACRONYM',
  MAXIMUM_SERVICE_TIME = 'MAXIMUM_SERVICE_TIME',
  SUPERIOR_SERVICE = 'SUPERIOR_SERVICE',
  PARENT_SERVICE = 'PARENT_SERVICE',
  SELECT_OPTION = 'SELECT_OPTION',
  NONE = 'NONE',
  LOCATIONS = 'LOCATIONS',
  LOCATION = 'LOCATION',
  RESOLUTIONS = 'RESOLUTIONS',
  RESOLUTION = 'RESOLUTION',
  RESOLUTION_REQUIRED_FOR_THIS_ACTION = 'RESOLUTION_REQUIRED_FOR_THIS_ACTION',
  SERVICE_GROUPS_THIS_LOCATION = 'SERVICE_GROUPS_THIS_LOCATION',
  AUTHORIZATION_NOT_FOUND = 'AUTHORIZATION_NOT_FOUND',
  INVALID_TOKEN = 'INVALID_TOKEN',
  USER_NOT_ALLOWED = 'USER_NOT_ALLOWED',
  ACCESS_DENIED_INSUFFICIENT_PERMISSION = 'ACCESS_DENIED_INSUFFICIENT_PERMISSION',
  LOCATION_ID_REQUIRED = 'LOCATION_ID_REQUIRED',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  UNKNOWN_OPERATION_ERROR = 'UNKNOWN_OPERATION_ERROR',
  ENTITY_ID_NOT_FOUND = 'ENTITY_ID_NOT_FOUND',
  EMPTY_ATTENDANCE_QUEUE = 'EMPTY_ATTENDANCE_QUEUE',
  ATTENDANCE_STATUS_CHANGE_ERROR = 'ATTENDANCE_STATUS_CHANGE_ERROR',
  INVALID_ATTENDANCE_TRANSITION = 'INVALID_ATTENDANCE_TRANSITION',
  ATTENDANCES = 'ATTENDANCES',
  ATTENDANCE = 'ATTENDANCE',
  ATTENDANTS = 'ATTENDANTS',
  ATTENDANT = 'ATTENDANT',
  ATTENDANCE_CALLED = 'ATTENDANCE_CALLED',
  ATTENDANCE_ENDED_AT = 'ATTENDANCE_ENDED_AT',
  ATTENDANCE_FINISHED = 'ATTENDANCE_FINISHED',
  ATTENDANCE_FORWARDED = 'ATTENDANCE_FORWARDED',
  ATTENDANCE_IN_PROGRESS = 'ATTENDANCE_IN_PROGRESS',
  ATTENDANCE_STARTED_AT = 'ATTENDANCE_STARTED_AT',
  ATTENDANCES_FOUND = 'ATTENDANCES_FOUND',
  ATTENDANCE_WAITING = 'ATTENDANCE_WAITING',
  CALL_NEXT = 'CALL_NEXT',
  CALL_AGAIN = 'CALL_AGAIN',
  CANCEL_FORWARDING = 'CANCEL_FORWARDING',
  CONFIRM_FORWARD_ATTENDANCE = 'CONFIRM_FORWARD_ATTENDANCE',
  START_ATTENDANCE = 'START_ATTENDANCE',
  END_ATTENDANCE = 'END_ATTENDANCE',
  FILL_FORWARDING_DATA = 'FILL_FORWARDING_DATA',
  FINISH_CURRENT_ATTENDANCE = 'FINISH_CURRENT_ATTENDANCE',
  FORWARD_ATTENDANCE = 'FORWARD_ATTENDANCE',
  FORWARD_ATTENDANCE_TARGET_REQUIRED = 'FORWARD_ATTENDANCE_TARGET_REQUIRED',
  FORWARDING_CREATES_NEW_ATTENDANCE = 'FORWARDING_CREATES_NEW_ATTENDANCE',
  INITIAL_OBSERVATION_FOR_NEW_ATTENDANCE = 'INITIAL_OBSERVATION_FOR_NEW_ATTENDANCE',
  NO_SHOW = 'NO_SHOW',
  CANCELLATIONS = 'CANCELLATIONS',
  NO_PRIORITY = 'NO_PRIORITY',
  NO_SHOW_DURING_ATTENDANCE = 'NO_SHOW_DURING_ATTENDANCE',
  NO_SHOW_ON_CALL = 'NO_SHOW_ON_CALL',
  NO_STATUS = 'NO_STATUS',
  NO_SERVICE = 'NO_SERVICE',
  BOOTH = 'BOOTH',
  REMOVE = 'REMOVE',
  RESUME_ATTENDANCE = 'RESUME_ATTENDANCE',
  SELECT_A_SERVICE = 'SELECT_A_SERVICE',
  SELECT_A_SERVICE_GROUP = 'SELECT_A_SERVICE_GROUP',
  SELECT_TARGET_SERVICE = 'SELECT_TARGET_SERVICE',
  SELECT_TARGET_SERVICE_GROUP = 'SELECT_TARGET_SERVICE_GROUP',
  SHOW_PANEL = 'SHOW_PANEL',
  CLICK_CALL_NEXT_TO_SELECT_TICKET = 'CLICK_CALL_NEXT_TO_SELECT_TICKET',
  NEXT_TICKETS_IN_QUEUE = 'NEXT_TICKETS_IN_QUEUE',
  LOADING_ATTENDANCES = 'LOADING_ATTENDANCES',
  PREVIOUS = 'PREVIOUS',
  NEXT = 'NEXT',
  PAGE = 'PAGE',
  SERVICE_GROUPS_THIS_ATTENDANT = 'SERVICE_GROUPS_THIS_ATTENDANT',
  SERVICES_PROVIDED = 'SERVICES_PROVIDED',
  SERVICE_ID_REQUIRED = 'SERVICE_ID_REQUIRED',
  SERVICE_ACRONYM_REQUIRED = 'SERVICE_ACRONYM_REQUIRED',
  TICKET_NUMBER_GENERATION_FAILED = 'TICKET_NUMBER_GENERATION_FAILED',
  OBSERVATION = 'OBSERVATION',
  TARGET_SERVICE = 'TARGET_SERVICE',
  TARGET_SERVICE_GROUP = 'TARGET_SERVICE_GROUP',
  TICKET_HISTORY = 'TICKET_HISTORY',
  TICKET_WAS_CALLED_AT = 'TICKET_WAS_CALLED_AT',
  TICKET_LABEL = 'TICKET_LABEL',
  TRIAGE_ERROR = 'TRIAGE_ERROR',
  UNASSIGNED = 'UNASSIGNED',
  USE_FIELDS_BELOW_TO_REGISTER_RESOLUTION = 'USE_FIELDS_BELOW_TO_REGISTER_RESOLUTION',
  OPEN_SIDE_PANEL = 'OPEN_SIDE_PANEL',
  COLLAPSE_SIDE_PANEL = 'COLLAPSE_SIDE_PANEL',
  NO_TICKET_IN_FOCUS = 'NO_TICKET_IN_FOCUS',
  LAST_MOVEMENT = 'LAST_MOVEMENT',
  SELECT_A_TICKET_TO_TRACK = 'SELECT_A_TICKET_TO_TRACK',
  ATTENDANCE_DURATION = 'ATTENDANCE_DURATION',
  IDLE_TIME = 'IDLE_TIME',
  ATTENDANCE_IN_PROGRESS_HINT = 'ATTENDANCE_IN_PROGRESS_HINT',
  WAITING_FOR_NEW_ATTENDANCE = 'WAITING_FOR_NEW_ATTENDANCE',
  PEOPLE_WAITING = 'PEOPLE_WAITING',
  CURRENT_BOOTH_QUEUE = 'CURRENT_BOOTH_QUEUE',
  NO_QUEUE_AT_THE_MOMENT = 'NO_QUEUE_AT_THE_MOMENT',
  NO_QUEUE = 'NO_QUEUE',
  CALLED_TICKETS = 'CALLED_TICKETS',
  NO_SHOW_TICKETS = 'NO_SHOW_TICKETS',
  QUEUE_HEALTH = 'QUEUE_HEALTH',
  VIEW_TICKET_HISTORY = 'VIEW_TICKET_HISTORY',
  OPERATIONAL_DATA = 'OPERATIONAL_DATA',
  AVERAGE_WAIT_TIME = 'AVERAGE_WAIT_TIME',
  MOST_DELAYED_SERVICE = 'MOST_DELAYED_SERVICE',
  AVERAGE_ATTENDANCE_TIME = 'AVERAGE_ATTENDANCE_TIME',
  TOTAL_ATTENDANCE_TIME = 'TOTAL_ATTENDANCE_TIME',
  ACCOUNT = 'ACCOUNT',
  HELP = 'HELP',
  LOGOUT = 'LOGOUT',
  REPORTS = 'REPORTS',
  PERFORMANCE = 'PERFORMANCE',
  ATTENDANCE_HEATMAP = 'ATTENDANCE_HEATMAP',
  ATTENDANCES_PER_HOUR = 'ATTENDANCES_PER_HOUR',
  ATTENDANCES_BY_ATTENDANT = 'ATTENDANCES_BY_ATTENDANT',
  ATTENDANCES_PER_MONTH = 'ATTENDANCES_PER_MONTH',
  ATTENDANCES_PER_DAY = 'ATTENDANCES_PER_DAY',
  MOST_REQUESTED_SERVICES = 'MOST_REQUESTED_SERVICES',
  PRIORITY_DISTRIBUTION = 'PRIORITY_DISTRIBUTION',
  NO_SHOW_AND_CANCELLATIONS = 'NO_SHOW_AND_CANCELLATIONS',
  QUEUE_EVOLUTION = 'QUEUE_EVOLUTION',
  PEOPLE_IN_QUEUE = 'PEOPLE_IN_QUEUE',
  AVERAGE_TIME = 'AVERAGE_TIME',
  DASHBOARD = 'DASHBOARD',
  FILTERS = 'FILTERS',
  PERIOD_GROUPING = 'PERIOD_GROUPING',
  GROUP_BY_DAY = 'GROUP_BY_DAY',
  GROUP_BY_WEEK = 'GROUP_BY_WEEK',
  GROUP_BY_MONTH = 'GROUP_BY_MONTH',
  ORDERING = 'ORDERING',
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  EXPORT_CSV = 'EXPORT_CSV',
  COMING_SOON = 'COMING_SOON',
  NO_ATTENDANCES_FOUND = 'NO_ATTENDANCES_FOUND',
  ALL = 'ALL',
  SERVICE_IN_USE_DEACTIVATE_INSTEAD = 'SERVICE_IN_USE_DEACTIVATE_INSTEAD',
  PRIORITY_IN_USE_DEACTIVATE_INSTEAD = 'PRIORITY_IN_USE_DEACTIVATE_INSTEAD',
  SERVICE_GROUP_IN_USE_DEACTIVATE_INSTEAD = 'SERVICE_GROUP_IN_USE_DEACTIVATE_INSTEAD',
  HEALTHCHECK = 'HEALTHCHECK',
  OPEN_HEALTHCHECK_DETAILS = 'OPEN_HEALTHCHECK_DETAILS',
  SYSTEM_HEALTHCHECK = 'SYSTEM_HEALTHCHECK',
  SUMMARY = 'SUMMARY',
  RECOMMENDED_ADJUSTMENTS = 'RECOMMENDED_ADJUSTMENTS',
  EVERYTHING_OK_HERE = 'EVERYTHING_OK_HERE',
  HEALTHCHECK_ISSUES_SUMMARY = 'HEALTHCHECK_ISSUES_SUMMARY',
  HEALTHCHECK_OK_SUMMARY = 'HEALTHCHECK_OK_SUMMARY',
  PROBLEMS_FOUND = 'PROBLEMS_FOUND',
  CATEGORY_WITH_ALERT = 'CATEGORY_WITH_ALERT',
  CATEGORIES_WITH_ALERT = 'CATEGORIES_WITH_ALERT',
  LAST_CHECK = 'LAST_CHECK',
  NO_HEALTHCHECK_ISSUES_FOUND = 'NO_HEALTHCHECK_ISSUES_FOUND',
  HOW_TO_FIX = 'HOW_TO_FIX',
  LOADING_CHECKS = 'LOADING_CHECKS',
  NO_DATA = 'NO_DATA',
  NO_ISSUES_FOUND = 'NO_ISSUES_FOUND',
  CLICK_TO_VIEW_DETAILS_AND_FIX = 'CLICK_TO_VIEW_DETAILS_AND_FIX',
  CLICK_TO_REVIEW_CHECKS = 'CLICK_TO_REVIEW_CHECKS',
  ATTENDANTS_WITH_INVALID_CONFIGURATION = 'ATTENDANTS_WITH_INVALID_CONFIGURATION',
  ATTENDANTS_INVALID_CONFIGURATION_DESCRIPTION = 'ATTENDANTS_INVALID_CONFIGURATION_DESCRIPTION',
  LOCATIONS_WITH_INVALID_CONFIGURATION = 'LOCATIONS_WITH_INVALID_CONFIGURATION',
  LOCATIONS_INVALID_CONFIGURATION_DESCRIPTION = 'LOCATIONS_INVALID_CONFIGURATION_DESCRIPTION',
  ORPHAN_ATTENDANCES_IN_QUEUE = 'ORPHAN_ATTENDANCES_IN_QUEUE',
  ORPHAN_ATTENDANCES_IN_QUEUE_DESCRIPTION = 'ORPHAN_ATTENDANCES_IN_QUEUE_DESCRIPTION',
  SERVICE_GROUPS_WITHOUT_SERVICES = 'SERVICE_GROUPS_WITHOUT_SERVICES',
  SERVICE_GROUPS_WITHOUT_SERVICES_DESCRIPTION = 'SERVICE_GROUPS_WITHOUT_SERVICES_DESCRIPTION',
  PRIORITIES_WITH_DUPLICATE_WEIGHT = 'PRIORITIES_WITH_DUPLICATE_WEIGHT',
  PRIORITIES_WITH_DUPLICATE_WEIGHT_DESCRIPTION = 'PRIORITIES_WITH_DUPLICATE_WEIGHT_DESCRIPTION',
  LINKED_GROUPS = 'LINKED_GROUPS',
  NO_LINKED_GROUPS = 'NO_LINKED_GROUPS',
  NOT_INFORMED = 'NOT_INFORMED',
  LINKED_LOCATION = 'LINKED_LOCATION',
  LINKED_LOCATIONS = 'LINKED_LOCATIONS',
  LINKED_ATTENDANT = 'LINKED_ATTENDANT',
  LINKED_ATTENDANTS = 'LINKED_ATTENDANTS',
  NO_SERVICE_GROUP_LINKED = 'NO_SERVICE_GROUP_LINKED',
  LINKED_GROUPS_WITHOUT_AVAILABLE_SERVICES = 'LINKED_GROUPS_WITHOUT_AVAILABLE_SERVICES',
  ATTENDANT_LINK_AT_LEAST_ONE_SERVICE_GROUP = 'ATTENDANT_LINK_AT_LEAST_ONE_SERVICE_GROUP',
  ATTENDANT_REVIEW_GROUPS_AND_ACTIVE_SERVICES = 'ATTENDANT_REVIEW_GROUPS_AND_ACTIVE_SERVICES',
  LOCATION_LINK_AT_LEAST_ONE_SERVICE_GROUP = 'LOCATION_LINK_AT_LEAST_ONE_SERVICE_GROUP',
  LOCATION_REVIEW_GROUPS_AND_ACTIVE_SERVICES = 'LOCATION_REVIEW_GROUPS_AND_ACTIVE_SERVICES',
  NO_COMPATIBLE_LOCATION_WITH_GROUP = 'NO_COMPATIBLE_LOCATION_WITH_GROUP',
  NO_ATTENDANT_LINKED_TO_GROUP = 'NO_ATTENDANT_LINKED_TO_GROUP',
  GROUP_ATTENDANTS_NOT_ENABLED_FOR_SERVICES = 'GROUP_ATTENDANTS_NOT_ENABLED_FOR_SERVICES',
  LINK_GROUP_TO_AT_LEAST_ONE_ACTIVE_LOCATION = 'LINK_GROUP_TO_AT_LEAST_ONE_ACTIVE_LOCATION',
  LINK_AT_LEAST_ONE_ATTENDANT_TO_GROUP = 'LINK_AT_LEAST_ONE_ATTENDANT_TO_GROUP',
  ENABLE_AT_LEAST_ONE_SERVICE_FOR_GROUP_ATTENDANTS = 'ENABLE_AT_LEAST_ONE_SERVICE_FOR_GROUP_ATTENDANTS',
  LINK_AT_LEAST_ONE_ACTIVE_SERVICE_TO_GROUP = 'LINK_AT_LEAST_ONE_ACTIVE_SERVICE_TO_GROUP',
  REVIEW_PRIORITY_REGISTRATIONS_UNIQUE_WEIGHT = 'REVIEW_PRIORITY_REGISTRATIONS_UNIQUE_WEIGHT',
  LINKS = 'LINKS',
  LINK = 'LINK',
  LINK_ENTITIES = 'LINK_ENTITIES',
  LINK_CHILD_ENTITIES_AFTER_CREATE_TITLE = 'LINK_CHILD_ENTITIES_AFTER_CREATE_TITLE',
  LINK_CHILD_ENTITIES_AFTER_CREATE_DESCRIPTION = 'LINK_CHILD_ENTITIES_AFTER_CREATE_DESCRIPTION',
  CREATED_ITEM = 'CREATED_ITEM',
  SELECT_CHILD_ENTITIES_TO_LINK = 'SELECT_CHILD_ENTITIES_TO_LINK',
  NO_CHILD_ENTITIES_AVAILABLE_FOR_LINKING = 'NO_CHILD_ENTITIES_AVAILABLE_FOR_LINKING',
  SELECT_ALL = 'SELECT_ALL',
  CLEAR_SELECTION = 'CLEAR_SELECTION',
  SKIP_FOR_NOW = 'SKIP_FOR_NOW',
  POST_CREATE_CHILD_NOTICE_TITLE = 'POST_CREATE_CHILD_NOTICE_TITLE',
  NEW_PRIORITY_CHILD_NOTICE = 'NEW_PRIORITY_CHILD_NOTICE',
  NEW_SERVICE_CHILD_NOTICE = 'NEW_SERVICE_CHILD_NOTICE',
  NEW_SERVICE_GROUP_CHILD_NOTICE = 'NEW_SERVICE_GROUP_CHILD_NOTICE',
  I_UNDERSTAND = 'I_UNDERSTAND',
  CATEGORY = 'CATEGORY',
  ENTITIES = 'ENTITIES',
  SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICES_WARNING = 'SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICES_WARNING',
  SELECTED_ENTITY_IS_NOT_PRINCIPAL_PRIORITIES_WARNING = 'SELECTED_ENTITY_IS_NOT_PRINCIPAL_PRIORITIES_WARNING',
  SELECTED_ENTITY_IS_NOT_PRINCIPAL_RESOLUTIONS_WARNING = 'SELECTED_ENTITY_IS_NOT_PRINCIPAL_RESOLUTIONS_WARNING',
  SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICE_GROUPS_WARNING = 'SELECTED_ENTITY_IS_NOT_PRINCIPAL_SERVICE_GROUPS_WARNING',
  SELECTED_ENTITY_IS_NOT_PRINCIPAL_ATTENDANTS_WARNING = 'SELECTED_ENTITY_IS_NOT_PRINCIPAL_ATTENDANTS_WARNING',
  CHILD_ENTITY_CAN_VIEW_LINKED_SERVICES_ONLY_ROOT_CAN_EDIT = 'CHILD_ENTITY_CAN_VIEW_LINKED_SERVICES_ONLY_ROOT_CAN_EDIT',
  CHILD_ENTITY_CAN_VIEW_LINKED_PRIORITIES_ONLY_ROOT_CAN_EDIT = 'CHILD_ENTITY_CAN_VIEW_LINKED_PRIORITIES_ONLY_ROOT_CAN_EDIT',
  CHILD_ENTITY_CAN_VIEW_LINKED_RESOLUTIONS_ONLY_ROOT_CAN_EDIT = 'CHILD_ENTITY_CAN_VIEW_LINKED_RESOLUTIONS_ONLY_ROOT_CAN_EDIT',
  CHILD_ENTITY_CAN_VIEW_LINKED_SERVICE_GROUPS_ONLY_ROOT_CAN_EDIT = 'CHILD_ENTITY_CAN_VIEW_LINKED_SERVICE_GROUPS_ONLY_ROOT_CAN_EDIT',
  CHILD_ENTITY_CAN_VIEW_LINKED_ATTENDANTS_ONLY_ROOT_CAN_EDIT = 'CHILD_ENTITY_CAN_VIEW_LINKED_ATTENDANTS_ONLY_ROOT_CAN_EDIT',
  SELECT_PRINCIPAL_ENTITY_TO_MANAGE_SHARED_LINKS = 'SELECT_PRINCIPAL_ENTITY_TO_MANAGE_SHARED_LINKS',
  CHOOSE_CATEGORY_THEN_ENTITY_TO_RECEIVE_ROOT_ITEMS = 'CHOOSE_CATEGORY_THEN_ENTITY_TO_RECEIVE_ROOT_ITEMS',
  ENTITIES_AVAILABLE_FOR_CATEGORY = 'ENTITIES_AVAILABLE_FOR_CATEGORY',
  SELECT_AN_ENTITY = 'SELECT_AN_ENTITY',
  SHARED_SERVICES_CATEGORY_DESCRIPTION = 'SHARED_SERVICES_CATEGORY_DESCRIPTION',
  LINKED_SERVICES_TITLE = 'LINKED_SERVICES_TITLE',
  SEARCH_SERVICE_PLACEHOLDER = 'SEARCH_SERVICE_PLACEHOLDER',
  NO_SERVICE_FOUND_FOR_THIS_FILTER = 'NO_SERVICE_FOUND_FOR_THIS_FILTER',
  SHARED_PRIORITIES_CATEGORY_DESCRIPTION = 'SHARED_PRIORITIES_CATEGORY_DESCRIPTION',
  LINKED_PRIORITIES_TITLE = 'LINKED_PRIORITIES_TITLE',
  SEARCH_PRIORITY_PLACEHOLDER = 'SEARCH_PRIORITY_PLACEHOLDER',
  NO_PRIORITY_FOUND_FOR_THIS_FILTER = 'NO_PRIORITY_FOUND_FOR_THIS_FILTER',
  SHARED_RESOLUTIONS_CATEGORY_DESCRIPTION = 'SHARED_RESOLUTIONS_CATEGORY_DESCRIPTION',
  LINKED_RESOLUTIONS_TITLE = 'LINKED_RESOLUTIONS_TITLE',
  SEARCH_RESOLUTION_PLACEHOLDER = 'SEARCH_RESOLUTION_PLACEHOLDER',
  NO_RESOLUTION_FOUND_FOR_THIS_FILTER = 'NO_RESOLUTION_FOUND_FOR_THIS_FILTER',
  SHARED_SERVICE_GROUPS_CATEGORY_DESCRIPTION = 'SHARED_SERVICE_GROUPS_CATEGORY_DESCRIPTION',
  LINKED_SERVICE_GROUPS_TITLE = 'LINKED_SERVICE_GROUPS_TITLE',
  SEARCH_SERVICE_GROUP_PLACEHOLDER = 'SEARCH_SERVICE_GROUP_PLACEHOLDER',
  NO_SERVICE_GROUP_FOUND_FOR_THIS_FILTER = 'NO_SERVICE_GROUP_FOUND_FOR_THIS_FILTER',
  SHARED_ATTENDANTS_CATEGORY_DESCRIPTION = 'SHARED_ATTENDANTS_CATEGORY_DESCRIPTION',
  LINKED_ATTENDANTS_TITLE = 'LINKED_ATTENDANTS_TITLE',
  SEARCH_ATTENDANT_PLACEHOLDER = 'SEARCH_ATTENDANT_PLACEHOLDER',
  NO_ATTENDANT_FOUND_FOR_THIS_FILTER = 'NO_ATTENDANT_FOUND_FOR_THIS_FILTER',
  SAVE_LINKS = 'SAVE_LINKS',
  LINKS_SAVED_SUCCESSFULLY = 'LINKS_SAVED_SUCCESSFULLY',
  ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICES = 'ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICES',
  ONLY_ROOT_ENTITY_CAN_MANAGE_PRIORITIES = 'ONLY_ROOT_ENTITY_CAN_MANAGE_PRIORITIES',
  ONLY_ROOT_ENTITY_CAN_MANAGE_RESOLUTIONS = 'ONLY_ROOT_ENTITY_CAN_MANAGE_RESOLUTIONS',
  ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICE_GROUPS = 'ONLY_ROOT_ENTITY_CAN_MANAGE_SERVICE_GROUPS',
  ONLY_ROOT_ENTITY_CAN_MANAGE_ATTENDANTS = 'ONLY_ROOT_ENTITY_CAN_MANAGE_ATTENDANTS',
  NO_SELECTED_ENTITY_TO_CREATE_SERVICES = 'NO_SELECTED_ENTITY_TO_CREATE_SERVICES',
  NO_SELECTED_ENTITY_TO_CREATE_PRIORITIES = 'NO_SELECTED_ENTITY_TO_CREATE_PRIORITIES',
  NO_SELECTED_ENTITY_TO_CREATE_RESOLUTIONS = 'NO_SELECTED_ENTITY_TO_CREATE_RESOLUTIONS',
  NO_SELECTED_ENTITY_TO_CREATE_SERVICE_GROUPS = 'NO_SELECTED_ENTITY_TO_CREATE_SERVICE_GROUPS',
  NO_SELECTED_ENTITY_TO_CREATE_ATTENDANTS = 'NO_SELECTED_ENTITY_TO_CREATE_ATTENDANTS',
  NO_SELECTED_ENTITY_TO_MANAGE_LOCATIONS = 'NO_SELECTED_ENTITY_TO_MANAGE_LOCATIONS',
  COULD_NOT_LOCATE_CONFIGURED_ROOT_ENTITY = 'COULD_NOT_LOCATE_CONFIGURED_ROOT_ENTITY',
  SIMILAR_NAME_WARNING_TITLE = 'SIMILAR_NAME_WARNING_TITLE',
  SIMILAR_NAME_WARNING_MESSAGE = 'SIMILAR_NAME_WARNING_MESSAGE',
  SIMILAR_NAME_DUPLICATE_MESSAGE = 'SIMILAR_NAME_DUPLICATE_MESSAGE',
}
